import { z } from 'zod'

import i18n from '@/locale/i18n'

export const requiredString = z.string().min(1, { message: 'error.validation.required' })
export const minNumber = (min: number) =>
  z.number().min(min, {
    message: i18n.t('error.validation.min_value', {
      min
    })!
  })
